import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react';

export type EmptyClassName = 'root' | 'group' | 'title' | 'message' | 'icon';

export type EmptyProps = {
	title: ReactNode;
	message: ReactNode;
	icon: ReactNode;
	classNames?: Partial<Record<EmptyClassName, string>>;
} & ComponentPropsWithoutRef<'div'>;

export const Empty = forwardRef<HTMLDivElement, EmptyProps>(
	({ icon, message, title, classNames, className, children, ...props }, ref) => (
		<div
			ref={ref}
			className={clsx('empty-root', className, classNames?.root)}
			{...props}
		>
			<div className={clsx('empty-icon', classNames?.icon)}>{icon}</div>
			<div className={clsx('empty-group', classNames?.group)}>
				<div className={clsx('empty-title', classNames?.title)}>{title}</div>
				<div className={clsx('empty-message', classNames?.message)}>{message}</div>
			</div>
			{children}
		</div>
	),
);
